import { render, staticRenderFns } from "./TableReferrals.vue?vue&type=template&id=6b0fd1c4&"
import script from "./TableReferrals.vue?vue&type=script&lang=js&"
export * from "./TableReferrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports